import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseInputComponent } from '../inputs/base-input/base-input.component';
import { Subject } from 'rxjs';
import { DateInputComponent } from '../inputs/date-input/date-input.component';
import { PathFinderService } from '../services/path-finder.service';

@Component({
  selector: 'app-mot-date-input',
  templateUrl: './mot-date-input.component.html',
  styleUrl: './mot-date-input.component.scss'
})
export class MotDateInputComponent extends BaseInputComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DateInputComponent) dateInput!: DateInputComponent;
  destroy$ = new Subject();
  value: Date;
  informedAnswer: Date;
  originalValue: Date;

  constructor(private pathFinder: PathFinderService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.informedAnswer = this.group.value.informedAnswer;
    this.originalValue = this.group.controls.value.value;
    if (this.informedAnswer !== this.originalValue) {
      this.pathFinder.appendAnswer('MOTDateChange', 'true');
    }
  }

  ngAfterViewInit(): void {
    this.dateInput.change.subscribe(group => {
      this.value = group.controls.value.value;
      if (this.informedAnswer !== this.value) {
        this.pathFinder.appendAnswer('MOTDateChange', 'true');
      } else {
        this.pathFinder.appendAnswer('MOTDateChange', 'false');
      }
    })

  }

  ngOnDestroy() {
    this.group.controls.value.reset();
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
